import React, { Component } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

import './Contact.css';

class Contact extends Component {
  render() {
    return (
      <div className="Contact" ref={div => (this.appContainer = div)}>
        <Header />
        <div className="Rooms-container">
          <div className="Content-top"></div>
          <div className="Content-mid">
            <div className="Content-header">CONTACT</div>
          </div>
          <div className="Content-bottom"></div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Contact;
